import PropTypes from 'prop-types';

import { TrlFormattedMessagePlain } from '»utils/i18n';

import { LinkStyled, MainTextStyled } from './TrlTextWithLink.styled';

export const TrlTextWithLink = ({
  mainText,
  hasDescrBalanced,
  linkText,
  handleLinkClick,
  children,
  href,
}) => {
  const printMainText = () => {
    if (mainText?.includes('TRLT_UI-'))
      return TrlFormattedMessagePlain({ id: mainText });

    return mainText;
  };

  const formattedLinkText =
    linkText && TrlFormattedMessagePlain({ id: linkText });

  if (!mainText) return null;

  return (
    <MainTextStyled className="screenDescr" hasDescrBalanced={hasDescrBalanced}>
      {printMainText()}
      {((linkText && handleLinkClick) || href) && (
        <>
          {' '}
          {href ? (
            <LinkStyled
              component="a"
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {formattedLinkText}
            </LinkStyled>
          ) : (
            <LinkStyled component="span" onClick={handleLinkClick}>
              {formattedLinkText}
            </LinkStyled>
          )}
        </>
      )}
      {children}
    </MainTextStyled>
  );
};

TrlTextWithLink.propTypes = {
  mainText: PropTypes.string,
  hasDescrBalanced: PropTypes.bool,
  linkText: PropTypes.string,
  handleLinkClick: PropTypes.func,
  children: PropTypes.element,
  href: PropTypes.string,
};
